import Styles from './styles.module.css';
import 'firebase/auth'
import React, { useState, useEffect } from 'react';
import DefaultTitle from '../../package/title/index';
import DefaultImage from './../../../image/default/home.png';
import Mail from './mail/index';
import { FaPencilAlt } from 'react-icons/fa';
import DefaultImg from './../../../image/default/account.png';
import { collection, doc, getDocs, getFirestore, query, updateDoc, where } from 'firebase/firestore';
import DefaultInput1 from '../../package/1-input/index';
import { getStorage, ref, uploadBytes } from 'firebase/storage';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/salon/app/hook';

const Setting: React.FC = () => {

  const company = useAppSelector((state) => state.company.company);

  const [ hintText, setHintText ] = useState<any>({ title: "", desc: "" });

  const [ time, setTime ] = useState<number>(0);

  const [ name, setName ] = useState(company.name);
  const [ mail, setMail ] = useState(false);
  const [ banner, setBanner ] = useState(false);

  const [ styleImageFile, setStyleImageFile ] = useState('');
  const [ styleImageFilePath, setStyleImageFilePath ] = useState<File | null>(null);

  useEffect(() => {
    var timeInit = new Date().getTime();
    setTime(timeInit);
  }, []);

  const styleImages = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setStyleImageFile(URL.createObjectURL(e.target.files[0]));
      setStyleImageFilePath(e.target.files[0]);
    }
  }

  async function save() {
    setBanner(true);

    const db = getFirestore();
    const storage = getStorage();

    await updateDoc(doc(db, "companies", company.id), {
      name: name,
    });

    if (styleImageFilePath) {
      const logoRef = ref(storage, `/companies_logo/${company.id}`);
      await uploadBytes(logoRef, styleImageFilePath);
    }

    const q = query(collection(db, "recruits"), where("companyId", "==", company.id));
    const snapShot = await getDocs(q);

    for (const recruitDoc of snapShot.docs) {
      await updateDoc(doc(db, "recruits", recruitDoc.id), {
        companyName: name,
      });
    }
    // 後に直す
    // dispatch(fetchCompanyState());

    setTimeout(() => {
      setBanner(false);
    }, 1500);
  }

  const auth = getAuth();
  const navigate = useNavigate();

  const logOut = async () => {
    await signOut(auth);
    navigate('/company/login');
  };
  
  return (
    <>
    <div className={Styles.box}>
      <div className={Styles.box_inline}>
        <div className={Styles.contents}>
          <h5 className={Styles.title}>基本情報</h5>

          <DefaultTitle title={'会社ロゴ'} />
          <div className={Styles.make_image}>
            <FaPencilAlt className={Styles.make_image_pen} />
            <input type='file' onChange={styleImages} />
            {styleImageFile === '' ?
              <img className={Styles.make_image_file}
              src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/companies_logo%2Fresize_images%2F${company.id}_500x500?alt=media&token=${time}`}
              onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = DefaultImage;
              }}/>
              :
              <img className={Styles.make_image_file} src={styleImageFile} />
            }
          </div>

          <DefaultInput1
            error={false}
            title={'企業名'} length={20} place={'memorii 株式会社'} value={name} setValue={setName} desc={'　'} hint={{title: "", desc: ""}} setHintText={setHintText} />

          <button className={Styles.save} onClick={() => save()}>保存</button>
        </div>


        <div className={Styles.contents}>

          <h5 className={Styles.title}>メール通知設定</h5>

          <div className={Styles.account}>
          
            <div className={Styles.account_user}>
              <h4>通知先アドレス</h4>
            </div>

            <div className={Styles.account_notification}>
              <p>{company.notification.mail === undefined ? "未登録": company.notification.mail}</p>
              <FaPencilAlt onClick={() => setMail(true)} className={Styles.account_icon} />
            </div>
            
          </div>

          <div style={{height : '30px'}}></div>

          <h5 className={Styles.title}>LINE通知設定</h5>

          <div className={Styles.account}>
            {company.notification.lineId !== "" ?
             <>
              <div className={Styles.account_user}>
                <img src={company.notification.linePicture}
                  onError={e => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = DefaultImg;
                  }}/>
                <h4>{company.notification.lineName}</h4>
              </div>

              <a 
                href={`https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=2006500323&redirect_uri=${encodeURIComponent('https://memorii-works.com/service/callback')}&state=${company.id}&scope=openid%20profile&nonce=SWFEng3EK6E3HNKyIOa-YT8NW5QIrtqEjYpY2sZoLMI`}

                className={Styles.account_alignment}>
                <div>
                  LINEと連携済み
                </div>
              </a>
              </>
              :
              <>
              <div className={Styles.account_user}>
                <img src={`https://linestep.jp/wp-content/uploads/2022/04/linelogo.png`}
                  onError={e => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = DefaultImg;
                  }}/>
                <h4>連携</h4>
              </div>

              <a 
                href={`https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=2006500323&redirect_uri=${encodeURIComponent('https://memorii-works.com/service/callback')}&state=${company.id}&scope=openid%20profile&nonce=SWFEng3EK6E3HNKyIOa-YT8NW5QIrtqEjYpY2sZoLMI`}
                className={Styles.account_alignment}>
                <div>
                  LINEと連携する
                </div>
              </a>
              </>
            }
          </div>

          <p className={Styles.desc_line}>※上記の連携が完了し次第、通知を行うための<a href='https://lin.ee/ApYAoTN'>公式LINE</a>を追加してください。</p>

          <a href='https://lin.ee/ApYAoTN'>
            <button className={Styles.btn_line}>通知用 公式LINE</button>
          </a>
        </div>
      </div>

      <div className={Styles.logout} onClick={() => logOut()}>
        <h4>ログアウト</h4>
      </div>
    </div>

    {mail ?
      <Mail mailAddress={company.notification.mail === undefined ? "" : company.notification.mail} setMail={setMail} />
    : <></> }

    {banner && <div className={Styles.banner}>保存しました。</div>}
    </>
  );
}

export default Setting;